<template>
  <div :class="clContainer()">
    <span
      v-if="label && (!hideLabelState || state != hideLabelState)"
      :class="clSub('label', 'label')"
      >{{ label }}</span
    >
    <p :class="clSub('value', textClass)">{{ text }}</p>

    <div :class="clSub('input', `form__input ${inputClass}`)">
      <div :class="clSub('input__select')">
        <span>{{ text }}</span>
        <select
          :id="id"
          :name="name"
          ref="select"
          :tabindex="tabindex"
          @input="
            data = $event.target.value;
            validate();
            dataChanged($event.target.value, true);
          "
          @click="focused"
        >
          <option v-for="(value, name) in doorinfo" :value="value" :key="value">
            {{ __(`jobs.common.parts.areas.door.${name}`) }}
          </option>
        </select>
      </div>
    </div>

    <div :class="clSub('errors')">
      <div
        v-for="(error, index) in errors"
        :class="clSub('error')"
        :key="index"
      >
        {{ error }}
      </div>
    </div>
  </div>
</template>

<script>
import Base from "./Base";

export default {
  extends: Base,
  props: {
    typeClass: {
      type: String,
      default: "select",
    },
    doorinfo: {
      type: Object,
    },
  },
  data() {
    return {
      isMounted: false,
      options: [],
    };
  },
  computed: {
    text() {
      if (!this.isMounted) {
        return "";
      }
      this.$refs.select.value = this.data;

      return this.data &&
        this.data.toString().length &&
        this.$refs.select.selectedIndex != -1
        ? this.$refs.select.options[this.$refs.select.selectedIndex].text
        : this.noValText;
    },
  },
  mounted() {
    this.isMounted = true;
  },
};
</script>

<style lang="scss" scoped>
.editable__element {
  &__input {
    background-color: white;

    &__select {
      position: relative;
      display: flex;
      align-items: center;

      &::after {
        display: block;
        content: url(../../../../img/icons/arrow-dropdown.svg);
      }

      > span {
        flex: 1 0 auto;
      }

      > select {
        position: absolute;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        width: 100%;
        opacity: 0;
        cursor: pointer;
      }
    }
  }
}
</style>